module.exports = __webpack_public_path__ + "media/stockholm/50disco-644cb69b.jpg";